import { Controller } from '@hotwired/stimulus';

// Controls ionic modal
export default class extends Controller {
  static targets = ['dialog'];
  connect() {
    var modal = this.dialogTarget;
    if (!modal) return;
    this.modal = modal;

    this.handleClose = this.handleClose.bind(this);
    this.modal.addEventListener('ionModalDidDismiss', this.handleClose);
  }

  disconnect() {
    if (this.modal) {
      this.modal.removeEventListener('ionModalDidDismiss', this.handleClose);
    }
  }

  openModal(event) {
    this.modal.isOpen = true;
    event.preventDefault();
  }

  handleClose() {
    this.modal.isOpen = false;
  }
}
